export const moneyFormat = {
  props: {
    locale: {
      type: String,
      default: 'nl'
    },
    currencyCode: {
      type: String,
      default: 'EUR'
    },
    supplementalPrecision: {
      type: Number,
      default: 0
    },
    subunitsValue: {
      type: Boolean,
      default: true
    },
    subunitsToUnit: {
      type: Number,
      default: 1
    },
    hideSubunits: {
      type: Boolean,
      default: false
    },
    bold: {
      type: String | Boolean,
      required: false
    }
  },
  methods: {
    //
    // Format money based on integer or floating input
    // ===============================================
    // Possible inputs are:
    // amount:                Numerical input (required)
    // locale:                Language and country information, such as 'en' or 'en-US'
    // currencyCode:          3-character code from ISO 4217
    // subunitsValue:         Value is denominated in subunits, such as cents
    // subunitsToUnits:       Overrides the minor unit value from ISO 4217. The "subunitsValue"
    //                        option is redundant if you enter a value for this
    // hideSubunits:          Set this to true if you don't want to display the subunits
    // supplementalPrecision: Allows you to display partial subunits . This is ignored if
    //                        you specify "hideSubunits=true"
    //
    formatMoney (amount) {
      let ret = 0
      if (Number.isFinite(parseInt(amount))) {
        try {
          let numFormat = new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currencyCode})
          let options = numFormat.resolvedOptions()
          if (this.subunitsToUnit > 1) {
            amount = amount / this.subunitsToUnit
          } else if (this.subunitsValue === true) {
            amount = amount / 10 ** options.minimumFractionDigits
          }
          if (this.hideSubunits === true) {
            numFormat = new Intl.NumberFormat(this.locale, {
              style: 'currency',
              currency: this.currencyCode,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
          } else if (this.supplementalPrecision > 0) {
            numFormat = new Intl.NumberFormat(this.locale, {
              style: 'currency',
              currency: this.currencyCode,
              minimumFractionDigits: options.minimumFractionDigits + this.supplementalPrecision,
              maximumFractionDigits: options.maximumFractionDigits + this.supplementalPrecision
            })
          }
          ret = numFormat.format(amount)
        } catch (err) {
          ret = err.message
        }
      } else {
        ret = 0
      }
      return ret
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/moneyFormat.js